var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"100vw","overflow-x":"hidden"},attrs:{"id":"app"}},[_c('NavCustom'),_c('div',{attrs:{"id":"fb-root"}}),_c('router-view'),_c('FooterCustom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }